import { Form, Radio, RadioChangeEvent } from 'antd';
import { Property } from 'csstype';
import { ChangeEventHandler } from 'react';


const RadioBox = (props: { label?: string, name: string, error?: string, Value1: string, Value2: string, Value3?: string, Value4?: string, LibValue1: string, libVlue2: string, libVlue3?: string, libVlue4?: string, width?: number, Taille?: number, etat?: boolean, disabled?: boolean, display?: Property.Display | undefined;defaultValue?:string,onchange?:((e: RadioChangeEvent) => void) | undefined }) => {
  return (
    
    <Form.Item
    className="bordure"
  name={props.name}
  label={props.label}
  labelCol={{ span: props.width }}          // Taille du label
  wrapperCol={{ span: props.width }}       // Taille des radios
  style={{ width: props.Taille }}
  initialValue={props.defaultValue}
  rules={[{ required: props.etat, message: props.error }]}
  //labelAlign="top" 
  // className="bordure"
  // name={props.name}
  // label={props.label}
  // labelCol={{ span: props.width, style: { whiteSpace: 'pre-wrap' } }}
  // wrapperCol={{ span: props.width }}  
  // style={{ color: 'darkblue', fontWeight: 600, width: props.Taille }}
  // initialValue={props.defaultValue}
  // rules={[{ required: props.etat, message: props.error }]}
  
>
  <Radio.Group onChange={props.onchange} disabled={props.disabled}>
    <Radio value={props.Value1}> {props.LibValue1} </Radio>
    <Radio value={props.Value2}> {props.libVlue2}</Radio>
    {props.Value3 && <Radio value={props.Value3}> {props.libVlue3}</Radio>}
    {props.Value4 && <Radio value={props.Value4}> {props.libVlue4}</Radio>}
  </Radio.Group>
    </Form.Item>
    // <Form.Item className='bordure' labelCol={{ span: props.width,style:{whiteSpace: 'pre-wrap'} }} style={{ color: 'darkblue', fontWeight: 600, width: props.Taille }} label={props.label}>
    //   <Form.Item
    //     initialValue={props.defaultValue}
    //     name={props.name}
    //     noStyle
    //     rules={[{ required: props.etat, message: props.error }]}>
    //     <Radio.Group onChange={props.onchange} disabled={props.disabled}>
    //       <Radio value={props.Value1}> {props.LibValue1} </Radio>
    //       <Radio value={props.Value2}> {props.libVlue2}</Radio>
    //       {props.Value3 ? <Radio value={props.Value3}> {props.libVlue3}</Radio> : <></>}
    //       {props.Value4 ? <Radio value={props.Value4}> {props.libVlue4}</Radio> : <></>}
    //     </Radio.Group>
    //   </Form.Item>
    // </Form.Item>
  );

}

export default RadioBox;